// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WTjd3K {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  height: 100%;
}

.SVUb2A {
  text-align: center;
}

.YBlQdg {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size, 20px);
  font-weight: var(--type-title-md-font-weight, 500);
  line-height: var(--type-title-md-line-height, 1.4);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.hVkkT1 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  width: 100%;
}

.gHkFjZ {
  width: 100%;
}

.gHkFjZ input {
  width: 100%;
  text-align: center;
  font-size: var(--type-display-sm-font-size, 32px);
  font-weight: var(--type-display-sm-font-weight, 600);
  height: 64px;
  padding: var(--spacing-2, 16px);
  border-radius: var(--radius-s, 8px);
}

.V_zWHv {
  color: var(--status-error-500, #e53e3e);
  font-size: var(--type-paragraph-sm-font-size, 12px);
  font-weight: var(--type-paragraph-sm-font-weight, 400);
  text-align: center;
  margin-top: 4px;
}

.itZ2eU {
  margin-top: var(--spacing-3);
  min-width: auto !important;
  width: 100%;
}

@media (max-width: 768px) {
  .WTjd3K {
    gap: 16px;
  }

  .YBlQdg {
    font-size: 18px;
  }

  .gHkFjZ input {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/HiringEmployees/HiringEmployees.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,kDAAkD;EAClD,kDAAkD;EAClD,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,oDAAoD;EACpD,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,mDAAmD;EACnD,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  height: 100%;\n}\n\n.explanationSection {\n  text-align: center;\n}\n\n.stepTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size, 20px);\n  font-weight: var(--type-title-md-font-weight, 500);\n  line-height: var(--type-title-md-line-height, 1.4);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.inputSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  width: 100%;\n}\n\n.employeeCountInput {\n  width: 100%;\n}\n\n.employeeCountInput input {\n  width: 100%;\n  text-align: center;\n  font-size: var(--type-display-sm-font-size, 32px);\n  font-weight: var(--type-display-sm-font-weight, 600);\n  height: 64px;\n  padding: var(--spacing-2, 16px);\n  border-radius: var(--radius-s, 8px);\n}\n\n.errorMessage {\n  color: var(--status-error-500, #e53e3e);\n  font-size: var(--type-paragraph-sm-font-size, 12px);\n  font-weight: var(--type-paragraph-sm-font-weight, 400);\n  text-align: center;\n  margin-top: 4px;\n}\n\n.infoAlert {\n  margin-top: var(--spacing-3);\n  min-width: auto !important;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    gap: 16px;\n  }\n\n  .stepTitle {\n    font-size: 18px;\n  }\n\n  .employeeCountInput input {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `WTjd3K`,
	"explanationSection": `SVUb2A`,
	"stepTitle": `YBlQdg`,
	"inputSection": `hVkkT1`,
	"employeeCountInput": `gHkFjZ`,
	"errorMessage": `V_zWHv`,
	"infoAlert": `itZ2eU`
};
module.exports = ___CSS_LOADER_EXPORT___;
